import React from "react";
import { ProgressBar } from 'react-bootstrap';

function getColor(value) {
    if (value < 500) return 'danger';
    if (value < 1000) return 'warning';
    return 'success';
  }


  const ProgressBarComp = ({ scoreNbrsMot }) => {
    const color = getColor(scoreNbrsMot);
    const now = (scoreNbrsMot / 1500) * 100;  // Calculer le pourcentage pour la barre de progression

    return (
      <div className="alert alert-light d-flex align-items-baseline mb-0">
          <span className="me-2">Nombre de mots (entre 1000 et 1500) : </span>


          <ProgressBar variant={color} now={now} label={`${scoreNbrsMot} mots`} className="flex-grow-1" />

        </div>
    );
  };

    export default ProgressBarComp;
